<template>
  <el-dialog
    :visible="true"
    width="90%"
    top="5vh"
    append-to-body
    :before-close="handleClose"
  >
    <div slot="title" style="text-align: center">
      <span class="fz18 fw500">选择开票人</span>
    </div>
    <table-render
      ref="userInfoTableRender"
      :config="tableConfig"
      height="55vh"
      rowKey="taxationId"
      :propData="propData"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { main } from './ApplyForCommissionUsers.config';

export default {
  name: 'invoiceOpenListUserInfo',
  props: {
    selection: {
      type: [Array],
      default: () => []
    },
    csoCustomOrderId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    tableRender: () => import('@C/tableRender/index')
  },
  data() {
    return {
      tableConfig: main
    };
  },
  computed: {
    propData() {
      return {
        query: {
          csoCustomOrderId: this.csoCustomOrderId
        }
      };
    }
  },
  methods: {
    handleClose() {
      this.remove();
    },
    submit() {
      this.$emit(
        'submit',
        this.$refs['userInfoTableRender'].$refs.table.store.states.selection
      );
      this.remove();
    },
    updateTableSelection() {
      if (this.selection.length) {
        this.$nextTick(() => {
          const p = {
            superKeys: this.selection.map(i => ({ taxationId: i.taxationId })),
            useSeachInit: false
          };
          this.$refs['userInfoTableRender'].selectAllByRowKey(p);
        });
      }
    }
  },
  mounted() {
    // 如果传入了 选择项 更新表格选择状态
    this.updateTableSelection();
  }
};
</script>

<style scoped></style>
